import { supabase } from "../../lib/supabaseClient";

/** Consider a user online if they pinged within this window. */
export const ONLINE_THRESHOLD_MS = 90_000;

function requireClient() {
  if (!supabase) throw new Error("Supabase is not configured.");
  return supabase;
}

export function isUserOnline(lastSeenAt, nowMs = Date.now()) {
  if (!lastSeenAt) return false;
  const t = new Date(lastSeenAt).getTime();
  if (!Number.isFinite(t)) return false;
  return nowMs - t < ONLINE_THRESHOLD_MS;
}

/** Heartbeat while the app is open — marks this user as online for others. */
export async function updateMyLastSeen(userId) {
  if (!userId) return;
  const { error } = await requireClient()
    .from("profiles")
    .update({ last_seen_at: new Date().toISOString() })
    .eq("id", String(userId));
  if (error) throw error;
}

export async function getUserLastSeen(userId) {
  if (!userId) return null;
  const { data, error } = await requireClient()
    .from("profiles")
    .select("last_seen_at")
    .eq("id", String(userId))
    .maybeSingle();
  if (error) throw error;
  return data?.last_seen_at ?? null;
}

export async function getUserPresence(userId) {
  const lastSeenAt = await getUserLastSeen(userId);
  return {
    lastSeenAt,
    online: isUserOnline(lastSeenAt),
  };
}
